export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_3.c94ecb4a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};